import React, { useState } from 'react'
import StoreStatusTable from './StoreStatusTable'
import CustomerStatusTable from './CustomerStatusTable'

const ListOfUsers = (props) => {

    const { customers = [], stores = [], activeStores = [] } = props
    const [selectedBtn, setSelectedBtn] = useState('store')




    const offlineStores = stores.filter((store) => !activeStores.includes(store));
    const offlineCount = offlineStores.length;
    const onlineCount = activeStores.length;


    const BtnStyle = {
        color: 'gray',
        margin: '0px 10px 0px 10px',
        fontSize: '15px',
        fontFamily: 'Inter Regular',
        backgroundColor: 'transparent',
        border: '1px solid lightgray',
        borderRadius: '3px',
        // border: 'none',
        cursor: 'pointer'
    }


    const BtnSelectedStyle = {
        color: '#181436',
        margin: '0px 5px 0px 10px',
        fontSize: '15px',
        fontFamily: 'Inter Bold',
        backgroundColor: 'white',
        border: '2px solid black',
        borderRadius: '3px',
        padding: '2px 8px 2px 8px',
        cursor: 'pointer'
    }



    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', margin: '20px' }}>
                <button style={selectedBtn === 'store' ? BtnSelectedStyle : BtnStyle} onClick={() => {
                    setSelectedBtn('store');
                }}>
                    {'Stores'}
                </button>
                <button style={selectedBtn === 'customer' ? BtnSelectedStyle : BtnStyle} onClick={() => {
                    setSelectedBtn('customer');
                }}>
                    {'Customers'}
                </button>

            </div>



            {selectedBtn === "store" && <StoreStatusTable stores={stores} activeStores={activeStores} />}
            {selectedBtn === "customer" && <CustomerStatusTable customers={customers} />}

        </>
    )
}

export default ListOfUsers